(function () {
	'use strict';
	angular.module('app.core')
		.service('itemDetailsPendingRequestsService', itemDetailsPendingRequestsService);

	itemDetailsPendingRequestsService.$inject = [];

	function itemDetailsPendingRequestsService($http, URLS) {
		var self = this;
		var pendingRequests = [];

		self.addRequest = addRequest;
		self.removeRequest = removeRequest;
		self.cancelPendingRequest = cancelPendingRequest;
		self.getPendingRequest = getPendingRequest;

		function addRequest(request) {
			pendingRequests.push(request);
		}

		function removeRequest(request) {
			pendingRequests = _.filter(pendingRequests, function(pendingRequest) {
				return pendingRequest.url !== request;
			});
		}

		function cancelPendingRequest() {
			angular.forEach(pendingRequests, function(pendingRequest) {
				pendingRequest.canceller.resolve();
			});
			pendingRequests.length = 0;
		}

		function getPendingRequest() {
			return pendingRequests;
		}
	}
})();
